export default "__VITE_ASSET__b823bdd2__"